import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/management/roles')({
  staticData: {
    breadcrumb: 'Roles',
  },
})
